import { Routes, Route, Navigate } from 'react-router-dom'
import Login from './routes/Login'
import Dashboard from './routes/Dashboard'
import Jobs from './routes/Jobs'
import Settings from './routes/Settings'
import Providers from './routes/admin/Providers'
import Consumers from './routes/admin/Consumers'
import Usage from './routes/admin/Usage'
import Layout from './components/Layout'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/admin/providers" element={<Providers />} />
        <Route path="/admin/consumers" element={<Consumers />} />
        <Route path="/admin/usage" element={<Usage />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
